import {
  ActionButton,
  Card,
  Checkbox,
  useGlobalNavigationHotkeys,
  useHotkeys,
} from "@permutation-city/ui";
import {
  Outlet,
  createRootRoute,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { UserBalance } from "../components/UserBalance";
import { useAppStore } from "../store/appStore";

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: () => {
    return (
      <p className="text-2xl font-bold text-center mt-24">404 NOT FOUND</p>
    );
  },
});

function Root() {
  const navigate = useNavigate();
  const location = useLocation();
  const { autoSwitch, setAutoSwitch } = useAppStore();
  useGlobalNavigationHotkeys();

  useHotkeys("^+T", () => {
    navigate({ to: "/terraform" });
  });
  useHotkeys("^+B", () => {
    navigate({ to: "/" });
  });

  return (
    <div className="grid grid-rows-[40px_auto] h-full min-w-0 min-h-0">
      <div className="flex items-center justify-between px-4">
        <ActionButton
          hotkey={location.pathname === "/terraform" ? "^+B" : "^+T"}
          onClick={() => {
            navigate({
              to: location.pathname === "/terraform" ? "/" : "/terraform",
            });
          }}
        >
          {location.pathname === "/terraform" ? "GO BACK" : "TERRAFORM"}
        </ActionButton>

        <div>
          <Checkbox
            name="switch"
            checked={autoSwitch}
            defaultChecked={autoSwitch}
            onChange={() => setAutoSwitch(!autoSwitch)}
          >
            AUTO-SWITCH
          </Checkbox>
        </div>

        <UserBalance />
      </div>

      <div className="h-full px-4 pb-4">
        <Card>
          <Outlet />
        </Card>
      </div>
    </div>
  );
}
